import { Action } from 'redux';
import { OnboardingData } from '@dev/ee-api/ee-api-models';
import { OnboardingSavedData, OnboardingVideoData } from '@/components/Onboarding/types';

export enum OnboardingActionTypes {
    SAVE_ONBOARDING_START = '@@onboarding/SAVE_ONBOARDING_START',
    SAVE_ONBOARDING_SUCCESS = '@@onboarding/SAVE_ONBOARDING_SUCCESS',
    SAVE_ONBOARDING_ERROR = '@@onboarding/SAVE_ONBOARDING_ERROR',

    LOAD_ONBOARDING_START = '@@onboarding/LOAD_ONBOARDING_START',
    LOAD_ONBOARDING_SUCCESS = '@@onboarding/LOAD_ONBOARDING_SUCCESS',
    LOAD_ONBOARDING_ERROR = '@@onboarding/LOAD_ONBOARDING_ERROR',

    OPEN_VIDEO_OVERLAY = '@@onboarding/OPEN_VIDEO_OVERLAY',
    CLOSE_VIDEO_OVERLAY = '@@onboarding/CLOSE_VIDEO_OVERLAY',

    FINISH_ONBOARDING = '@@onboarding/FINISH_ONBOARDING',
}

export interface SaveOnboardingStartAction extends Action {
    type: OnboardingActionTypes.SAVE_ONBOARDING_START;
    payload: Partial<OnboardingSavedData>;
}

export interface SaveOnboardingSuccessAction extends Action {
    type: OnboardingActionTypes.SAVE_ONBOARDING_SUCCESS;
}

export interface SaveOnboardingErrorAction extends Action {
    type: OnboardingActionTypes.SAVE_ONBOARDING_ERROR;
}

export interface LoadOnboardingStartAction extends Action {
    type: OnboardingActionTypes.LOAD_ONBOARDING_START;
}

export interface LoadOnboardingSuccessAction extends Action {
    type: OnboardingActionTypes.LOAD_ONBOARDING_SUCCESS;
    payload: OnboardingData;
}

export interface LoadOnboardingErrorAction extends Action {
    type: OnboardingActionTypes.LOAD_ONBOARDING_ERROR;
}

export interface OpenVideoOverlayAction extends Action {
    type: OnboardingActionTypes.OPEN_VIDEO_OVERLAY;
    payload: OnboardingVideoData;
}

export interface CloseVideoOverlayAction extends Action {
    type: OnboardingActionTypes.CLOSE_VIDEO_OVERLAY;
}

export interface FinishOnboardingAction extends Action {
    type: OnboardingActionTypes.FINISH_ONBOARDING;
}
export enum OnboardingLoadingState {
    Default = '',
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error',
}
export interface OnboardingState {
    isSaved: boolean;
    isSaving: boolean;
    loaded: OnboardingLoadingState;
    data?: OnboardingData;
    savedData?: OnboardingSavedData;
    openVideo?: string;
    isAlreadySaved: boolean;
    isFinished?: boolean;
}
